// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__2SbM2","select":"Header_select__3E6ij","clinic":"Header_clinic__1qJC_"};